export default __webpack_public_path__ + "static/media/property_986.76f647d5.png";